import BaseModulePlugins from '@/store/baseModule/plugins';
import AlertsService, {
  getSensorsQuality,
  getEnergyCases,
} from '@/services/services/alerts.service';
import registerUntreated, { UNTREATED_ALERTS_MODULE_PATH } from './untreated';
import registerTabModule from '@/store/TabModule';
import alertsModule from './module';

export default (store) => {
  store.registerModule(['alerts'], alertsModule(AlertsService));

  const basePlugin = new BaseModulePlugins({
    module: 'alerts',
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.onInit(() => {
    store.subscribe((mutation) => {
      if (mutation.type === 'entities/SET_CURRENT') {
        store.dispatch(`alerts/setGlobalSearch`, null);
      }
    });
    basePlugin.persistVuexMutationsToLocalStorage(['SET_ATTRIBUTES_OBJ']);

    basePlugin.onItemsLoaded((items) => {
      const idList = items.map((item) => item.property_id);
      getSensorsQuality(items)
        .then(async (resultList) => {
          store.commit('alerts/SET_SENSORS_QUALITY', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
      getEnergyCases(idList)
        .then(async (resultList) => {
          store.commit('alerts/SET_ENERGY_CASES', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
    });
  });

  registerUntreated(store);

  registerTabModule({
    namespace: ['alerts', 'table'],
    tabs: [UNTREATED_ALERTS_MODULE_PATH, 'alerts'],
    store,
    customGetters: {
      isUnTreatedAlertsShowed: (state) =>
        state.currentNamespace === UNTREATED_ALERTS_MODULE_PATH,
    },
  });
};
